export default "__VITE_ASSET__8fd86798__"